export const AGENT_SPEC_AUTHORING_PATH = '/studio/agent-spec'

const ORGANIZATION_ID_PARAM = 'organizationId'
const AGENT_ID_PARAM = 'agentId'
const LEGACY_RUNTIME_TARGET_PARAM = 'deploymentId'

export function isAgentSpecAuthoringPath(pathname: string): boolean {
  return (
    pathname === AGENT_SPEC_AUTHORING_PATH ||
    pathname.startsWith(`${AGENT_SPEC_AUTHORING_PATH}/`)
  )
}

export function readContextTargetId(
  pathname: string,
  searchParams: URLSearchParams,
): string | null {
  return searchParams.get(
    isAgentSpecAuthoringPath(pathname)
      ? AGENT_ID_PARAM
      : LEGACY_RUNTIME_TARGET_PARAM,
  )
}

export function reconcileContextSearch({
  pathname,
  search,
  organizationId,
  agentId,
}: {
  pathname: string
  search: string
  organizationId: string | null
  agentId: string | null
}): { changed: boolean; search: string } {
  const params = new URLSearchParams(search)
  const initialSearch = params.toString()

  if (organizationId) {
    params.set(ORGANIZATION_ID_PARAM, organizationId)
  } else {
    params.delete(ORGANIZATION_ID_PARAM)
  }

  if (isAgentSpecAuthoringPath(pathname)) {
    params.delete(LEGACY_RUNTIME_TARGET_PARAM)
    if (agentId) {
      params.set(AGENT_ID_PARAM, agentId)
    }
  } else if (agentId) {
    params.set(LEGACY_RUNTIME_TARGET_PARAM, agentId)
  } else {
    params.delete(LEGACY_RUNTIME_TARGET_PARAM)
  }

  const nextSearch = params.toString()
  return { changed: nextSearch !== initialSearch, search: nextSearch }
}

export function agentSpecAuthoringHref(
  organizationId: string | null | undefined,
  agentId: string | null | undefined,
): string {
  const params = new URLSearchParams()
  if (organizationId) params.set(ORGANIZATION_ID_PARAM, organizationId)
  if (agentId) params.set(AGENT_ID_PARAM, agentId)
  const search = params.toString()
  return `${AGENT_SPEC_AUTHORING_PATH}${search ? `?${search}` : ''}`
}
